import { render, staticRenderFns } from "./BeerSmart.vue?vue&type=template&id=4905d45a&"
import script from "./BeerSmart.vue?vue&type=script&lang=js&"
export * from "./BeerSmart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports